import Vue from 'vue'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import TimeFrame from '../mixins/timeframe-mixins'
import toastr from '../toastr'
import DcForm from '../../component/dccore-form/dcForm.vue'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import Checkbox from '../../component/dccore-form/checkbox.vue'
import datePicker from '../../component/dccore-form/datePicker.vue'
import BagItemEdit from './bagItemEdit.vue'
import BagItemCreate from './bagItemCreate.vue'
import BagOrderIds from './bagOrderIds.vue'
import BootstrapVue from 'bootstrap-vue'
import Note from './../../../../src/Netinteractive/NoteBundle/public/js/vue/note.vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import moment from 'moment'
import 'moment/locale/pl'
import History from './history.vue'
import SingleSelect from '../../component/singleselect.vue'

if ($('#bag_form').length) {
  Vue.use(VueResource)
  Vue.use(BootstrapVue)
  new Vue({
    el: '#bag_form',
    components: {
      RingLoader,
      DcForm,
      Multiselect,
      TextInput,
      NumberInput,
      Singleselect,
      Checkbox,
      datePicker,
      BagItemCreate,
      BagItemEdit,
      BagOrderIds,
      Note,
      History,
      SingleSelect,
    },
    mixins: [mixins, TimeFrame],
    data: {
      bagItemId: null,
      bagId: null,
      brandId: null,
      loading: 0,
      save: false,
      saveBagItemFlag: false,
      hasComment: false,
      addresses: [],
      statuses: [],
      displayBrand: '',
      selected: false,
      date: null,
      bagRoutes: [],
      disableAddressChange: false,
      cancelNewStructureSucceed: false,
      disableDeliveryDateChange: false,
      disableResignElement: false,
      disableChangeMenu: false,
      bag: {
        id: null,
        highlightDriver: false,
        comment: null,
        status: null,
        user: null,
        route: null,
        priceLeftToPay: 0,
        pricePaidFromMoneybox: 0,
        pricePaidFromWallet: 0,
        variant: null,
        package: null,
      },
      form: {
        options: {
          errors: {},
        }
      },
      packages: [],
      variants: [],
      bagItemsStatuses: [
        {
          id: 0,
          value: Translator.trans('bag_item.payment_status.empty')
        }
      ],
      selectedStatus: null,
      emptyFilterValue: 0,
    },
    computed: {
      activeAddresses: function () {
        return this.addresses.filter((address) => {
          return address.id === this.bag.address || address.isActive
        })
      },
      pricePaidFromMoneybox: {
        get: function () {
          return this.bag.pricePaidFromMoneybox !== null ?
            this.bag.pricePaidFromMoneybox.toFixed(2).toString().replace('.', ',') :
            null
        },
        set: function () {}
      },
      pricePaidFromWallet: {
        get: function () {
          return this.bag.pricePaidFromWallet !== null ?
            this.bag.pricePaidFromWallet.toFixed(2).toString().replace('.', ',') :
            null
        },
        set: function () {}
      },
      priceLeftToPay: {
        get: function () {
          return this.bag.priceLeftToPay !== null ?
            this.bag.priceLeftToPay.toFixed(2).toString().replace('.', ',') :
            null
        },
        set: function () {}
      },
      priceDiscountDisplay: {
        set: function () {
        },
        get: function () {
          if (this.bag) {
            let percent = Math.round((this.bag.priceDiscount / this.bag.priceBeforeDiscount) * 100 * 100) / 100

            if (!isNaN(percent)) {
              return `${this.dcNumberFormat(this.bag.priceDiscount)} (${this.dcNumberFormat(percent)}%)`
            } else {
              return 0
            }
          }
          return null
        }
      },
      filteredBagItems: function() {
        return this.selectedStatus ?
          this.bag.bagItems.filter((item) => item.status.id === this.selectedStatus) :
          this.bag.bagItems
      },
      filteredBagItemsDelivery: function() {
        return this.selectedStatus ?
          this.bag.bagItemsDelivery.filter((item) => item.status.id === this.selectedStatus) :
          this.bag.bagItemsDelivery
      },
    },
    watch: {
      'selected': function (newVal) {
        this.bag.bagItems.forEach(bagItem => {
          bagItem.selected = newVal
        })
      },
      'bag.user': function (id) {
        if (id !== null) {
          this.loading++
          let url = Routing.generate('api_get_client', { id: id,
            context: 'list' })

          Vue.http.get(url).then(response => {
            this.displayBrand = response.data.brandName
            this.brandId = response.data.brand
            this.loading--
          }, response => {
            this.handleAjaxError(response)
            this.loading--
          })
        }
      },
      'bag.deliveryDate' : function () {
        if (this.date && this.date !== this.bag.deliveryDate) {
          this.bag.highlightDriver = false
          this.bag.comment = ''
        }
      },
      'bag.package': function () {
        this.getVariants()
      },
      brandId(value) {
        this.getVariants(value)
      }
    },
    mounted: async function () {
      if ($('#entity_id').length) {
        this.bagId = $('#entity_id').val()
        this.getBag()
      }
      this.getStatuses()
      this.getBagItemsStatuses()
      this.getPackages()
      await this.validateTimeFrames()
    },
    methods: {
      sortBagItems() {
        if (this.bag && this.bag.bagItems) {
          this.bag.bagItems.sort((first, second) => {
            if (null === first.mealType || null === second.mealType
                            || first.mealType.position < second.mealType.position) {
              return -1
            }
            if (first.mealType.position > second.mealType.position) {
              return 1
            }
            return 0
          })
        }
      },
      updateBag: async function (redirect) {
        this.form.options.errors = {}

        let url = Routing.generate('api_patch_bag', { id: this.bagId })
        let data = this.bag

        if (!data.package) {
          data.package = null
        }
        if (!data.variant) {
          data.variant = null
        }

        Vue.http.patch(url, {
          data
        }).then(() => {
          let referer = Routing.generate('diet_update', { id: this.bag.diet })

          if (redirect) {
            $(location).attr('href', referer)
          } else {
            this.form.options.errors = {}
            this.getBag()
            toastr.success(this.trans('form.updated'))
          }

          this.validateTimeFrames()
        }, response => {
          this.handleAjaxError(response, this.form.options)
        })
      },
      getBag: function () {
        this.loading++

        let url = Routing.generate('api_get_bag', { id: this.bagId,
          context: 'bag' })

        Vue.http.get(url).then(response => {
          let packages = response.data.bagItems
            .filter(item => item.package)
            .map(item => item.package.id)
          if ([...new Set(packages)].length === 1) {
            response.data.package = packages[0]
          }

          let variants = response.data.bagItems
            .filter(item => item.variant)
            .map(item => item.variant.id)
          if ([...new Set(variants)].length === 1) {
            response.data.variant = variants[0]
          }

          this.bag = response.data
          this.date = (new moment(this.bag.deliveryDate)).format('YYYY-MM-DD')
          this.hasComment = (this.bag.comment !== null)
          this.sortBagItems()
          this.selected = false

          this.loading--

          this.getAddresses()
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getAddresses() {
        this.loading++
        let url = Routing.generate('api_get_addresses', {
          'user': this.bag.user,
          'date': this.bag.deliveryDate,
          skipType: true,
          context: 'dropdown'
        })
        this.$http.get(url).then(response => {
          this.addresses = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      trans(name) {
        return Translator.trans(name)
      },
      editBagItem(bagItemId) {
        this.bagItemId = bagItemId
        this.$refs.editBagItemModal.show()
      },
      createBagItem() {
        this.$refs.createBagItemModal.show()
      },
      removeBagItem(bagItemId) {
        if (confirm(this.trans('form.confirm'))) {
          this.loading++
          let url = Routing.generate('api_remove_bagitem', { id: bagItemId })

          Vue.http.delete(url).then(() => {
            this.loading--
            this.getBag()
            toastr.success(Translator.trans('form.removed'))
          }, response => {
            this.loading--
            this.handleAjaxError(response)
          })
        }
      },
      saveTagItem(e) {
        e.preventDefault()
        this.save = true
      },
      tagItemSaved() {
        this.save = false
        this.$refs.editBagItemModal.hide()
        this.getBag()
      },
      tagItemSaveFailed() {
        this.save = false
      },
      getStatuses() {
        this.loading++
        let url = Routing.generate('api_get_tags', {
          type: 'ecommerce_bag_status',
          context: 'dropdown'
        })
        this.$http.get(url).then(response => {
          this.statuses = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      saveBagItem(e) {
        e.preventDefault()
        this.saveBagItemFlag = true
      },
      bagItemSaved() {
        this.saveBagItemFlag = false
        this.$refs.createBagItemModal.hide()
        this.getBag()
      },
      bagItemSaveFailed() {
        this.saveBagItemFlag = false
      },
      cancelNewStructure() {
        let url = Routing.generate('api_resign_bagitem')
        let bagItemIds = []
        this.bag.bagItems.forEach(bagItem => {
          if (bagItem.selected) {
            bagItemIds.push(bagItem.id)
            bagItem.selected = false
          }
        })
        this.selected = false
        this.loading++
        this.$http.post(url, { bagItemIds: bagItemIds }).then(() => {
          this.getBag()
          this.cancelNewStructureSucceed = true
          this.loading--
        }, response => {
          this.cancelNewStructureSucceed = false
          this.handleAjaxError(response)
          if (response.status === 422) {
            toastr.error(response.body.messages.join(', '))
          }
          this.loading--
        })
      },
      cancel() {
        let bagItemIds = []

        this.bag.bagItems.forEach(bagItem => {
          if (bagItem.selected) {
            bagItemIds.push(bagItem.id)
            bagItem.selected = false
          }
        })
        this.selected = false

        this.loading++

        let url = Routing.generate('api_cancel_bagitem')

        this.$http.post(url, bagItemIds).then(() => {
          this.getBag()
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      async validateTimeFrames() {
        this.loading++
        this.disableAddressChange = !(await this.validateTimeFrame(this.bagId, 'addressChangeTo'))
        this.disableDeliveryDateChange = !(await this.validateTimeFrame(this.bagId, 'deliveryChangeDate'))
        this.disableResignElement = !(await this.validateTimeFrame(this.bagId, 'resignElementTo'))
        this.disableChangeMenu = !(await this.validateTimeFrame(this.bagId, 'menuChangeTo'))
        this.loading--
      },
      getPackages() {
        this.loading++
        let url = Routing.generate('api_get_packages', { context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.packages = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getVariants(brandId = null) {
        let pathName = null
        const pathArgs = {
          context: 'list',
        }

        if (this.bag.package) {
          pathName = 'api_get_package_variants'
          pathArgs.id = this.bag.package
        } else if (brandId) {
          pathName = 'api_get_variants_for_brand'
          pathArgs.brand = brandId
        } else {
          return
        }

        this.loading++
        let url = Routing.generate(pathName, pathArgs)

        Vue.http.get(url).then(response => {
          this.variants = response.data

          let variantExist = false
          let i

          for (i = 0; i < this.variants.length; i++) {
            if (String(this.bag.variant) === String(this.variants[i].id)) {
              variantExist = true
              break
            }
          }

          if (!variantExist) {
            this.bag.variant = null
          }

          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      clearPartStatus(partId, i) {
        if (confirm(Translator.trans('bag.form.confirm_clear_status'))) {
          this.loading++
          let url = Routing.generate('api_get_clear_delivery_packaging_part_status', {
            id: partId
          })
          Vue.http.get(url).then(() => {
            this.bag.deliveryPackagingParts[i].status = null
            this.loading--
          })
        }
      },
      getBagItemsStatuses() {
        this.loading++
        let url = Routing.generate('api_get_tags', {
          type: 'ecommerce_bag_item_status',
          context: 'dropdown'
        })
        this.$http.get(url).then(response => {
          this.bagItemsStatuses = [...this.bagItemsStatuses, ...response.data]
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
    }
  })
}
